import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getUserByIdApi } from "../../../api/userService";
import Pagination from "../../Pagination/Pagination";

export default function ViewUser() {
  const location = useLocation();
  const id = location?.state?.userId;
  console.log(id)
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 10;

  useEffect(() => {
    if (id) {
      fetchUser(currentPage);
    }
  }, [id, currentPage]);

  const fetchUser = async (page = 1) => {
    try {
      setLoading(true);

      const response = await getUserByIdApi(id, page);

      setUser(response.data);
    } catch (error) {
      console.error("Error fetching user:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container-fluid p-4">
        <div className="card p-3 text-center">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="container-fluid p-4">
        <div className="card p-3 text-center">User not found</div>
      </div>
    );
  }
  const allOrderItems =
    user?.orders?.data?.flatMap((order) =>
      order.items.map((item, index) => ({
        ...item,
        orderId: order.orderId,
        rowKey: `${order._id}-${index}`,
      })),
    ) || [];

  return (
    <div className="container-fluid p-4">
       <h5 className="mb-3 text-dark fw-bold">View User</h5>

      <div className="card p-3">
        <div className="mb-3">
          

          <div className="row">
            <div className="col-md-6 mt-0">
              <strong>Name :</strong> {user.name || "-"}
            </div>

            <div className="col-md-6 mt-0">
              <strong>Email :</strong> {user.email || "-"}
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <strong>Phone :</strong> {user.phone || "-"}
            </div>

            <div className="col-md-6">
              <strong>Orders Count :</strong> {user?.orders?.data?.length || 0}
            </div>
          </div>
        </div>
       <div className="mb-3">
  <h5 className="mb-3 text-dark fw-bold">Addresses</h5>

  {user?.addresses?.length > 0 ? (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>#</th>
          <th>Receiver Name</th>
          <th>Receiver No</th>
          <th>Address</th>
          <th>Primary</th>
        </tr>
      </thead>

      <tbody>
        {user.addresses.map((address, index) => (
          <tr key={address._id}>
            <td>{index + 1}</td>
            <td>{address.receiverName}</td>
            <td>{address.receiverNo}</td>
            
            <td>
              {address.addressLine1}
              {address.addressLine2 ? `, ${address.addressLine2}` : ""}
              {address.landMark ? `, ${address.landMark}` : ""}
            </td>
            <td>{address.isPrimary ? "Yes" : "No"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <p>No Addresses Found</p>
  )}
</div>
        <div className="">
          <h5 className="mb-3mb-3 text-dark fw-bold">Orders</h5>

          {user?.orders?.data?.length > 0 ? (
            <>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Product Name</th>
                    <th>Text</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Size</th>
                    <th>Material</th>
                    <th>Font</th>
                    <th>Color</th>
                  </tr>
                </thead>

                <tbody>
                  {user.orders.data.map((order) =>
                    order.items.map((item, index) => (
                      <tr key={`${order._id}-${index}`}>
                        <td>{order.orderId}</td>
                        <td>{item.name}</td>
                        <td>{item.customText}</td>
                        <td>{item.quantity}</td>
                        <td>₹{item.price}</td>
                        <td>{item.selections?.sizeId?.value || "-"}</td>
                        <td>{item.selections?.materialId?.value || "-"}</td>
                        <td>{item.selections?.fontId?.value || "-"}</td>
                        <td>{item.selections?.colorId?.name || "-"}</td>
                      </tr>
                    )),
                  )}
                </tbody>
              </table>
              <Pagination
                totalItems={user?.orders?.pagination?.total || 0}
                itemsPerPage={user?.orders?.pagination?.limit || 10}
                currentPage={user?.orders?.pagination?.page || 1}
                onPageChange={(page) => {
                  setCurrentPage(page);
                }}
              />
            </>
          ) : (
            <p>No Orders Found</p>
          )}
        </div>
      </div>
    </div>
  );
}
